(() => {
  document.querySelectorAll('[data-cw-header]').forEach((root) => {
    if (root.dataset.cwReady === 'true') return;
    root.dataset.cwReady = 'true';

    const cartLink = root.querySelector('.cw-header__cart');
    const cartContainers = [...document.querySelectorAll('[data-section-type="cart"], [data-section-type="quick-cart"]')];
    const updateCartCount = (count) => {
      if (!cartLink || !Number.isSafeInteger(count) || count < 0) return;
      const label = count === 1 ? cartLink.dataset.cwCartLabelOne : cartLink.dataset.cwCartLabelOther;
      if (label) cartLink.setAttribute('aria-label', label.replace('__CW_COUNT__', String(count)));
      let badge = cartLink.querySelector('b');
      if (count === 0) {
        badge?.remove();
      } else {
        if (!badge) {
          badge = document.createElement('b');
          cartLink.appendChild(badge);
        }
        badge.textContent = String(count);
      }
    };
    const syncRenderedCartCount = () => {
      const cart = cartContainers.find((container) => container.dataset.sectionType === 'cart') || cartContainers[0];
      if (!cart) return;
      const quantities = [...cart.querySelectorAll('input[name="updates[]"]')];
      updateCartCount(quantities.reduce((total, input) => total + Number(input.value || 0), 0));
    };
    if (cartContainers.length) {
      const cartObserver = new MutationObserver(syncRenderedCartCount);
      cartContainers.forEach((container) => cartObserver.observe(container, { childList: true, subtree: true }));
      syncRenderedCartCount();
    }
    document.addEventListener('cart:updated', (event) => updateCartCount(event.detail?.cart?.item_count));

    const menu = root.querySelector('[data-cw-mobile-menu]');
    const panel = root.querySelector('[data-cw-menu-panel]');
    const openButton = root.querySelector('[data-cw-menu-open]');
    const closeButtons = root.querySelectorAll('[data-cw-menu-close]');
    const promiseBar = root.querySelector('.cw-header__promise');
    const mainRow = root.querySelector('[data-cw-main-row]');
    const mobileSearch = root.querySelector('.cw-header__mobile-search-wrap');
    let returnFocus = null;
    let ticking = false;

    const focusableElements = () => panel
      ? [...panel.querySelectorAll('a[href], button:not([disabled]), summary, input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])')]
          .filter((element) => !element.hidden && element.getClientRects().length)
      : [];

    const openMenu = () => {
      if (!menu || !panel) return;
      returnFocus = document.activeElement;
      menu.hidden = false;
      document.body.classList.add('cw-menu-open');
      openButton?.setAttribute('aria-expanded', 'true');
      requestAnimationFrame(() => (focusableElements()[0] || panel).focus());
    };

    const closeMenu = () => {
      if (!menu) return;
      menu.hidden = true;
      document.body.classList.remove('cw-menu-open');
      openButton?.setAttribute('aria-expanded', 'false');
      if (returnFocus instanceof HTMLElement) returnFocus.focus();
    };

    const trapFocus = (event) => {
      if (event.key === 'Escape') {
        closeMenu();
        return;
      }
      if (event.key !== 'Tab' || !menu || menu.hidden) return;
      const focusable = focusableElements();
      if (!focusable.length) {
        event.preventDefault();
        panel?.focus();
        return;
      }
      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    };

    const updateStickyState = () => {
      ticking = false;
      const isMobile = window.matchMedia('(max-width: 989px)').matches;
      const rootTop = root.getBoundingClientRect().top + window.scrollY;
      const promiseHeight = promiseBar?.offsetHeight || 0;
      const mainHeight = mainRow?.offsetHeight || 0;
      const mobileSearchHeight = mobileSearch?.offsetHeight || 0;
      if (isMobile) {
        root.classList.remove('is-nav-stuck');
        root.classList.toggle('is-mobile-stuck', window.scrollY > rootTop + promiseHeight + mainHeight + mobileSearchHeight);
      } else {
        root.classList.remove('is-mobile-stuck');
        root.classList.toggle('is-nav-stuck', window.scrollY > rootTop + promiseHeight + mainHeight);
      }
    };

    const requestStickyUpdate = () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(updateStickyState);
    };

    openButton?.addEventListener('click', openMenu);
    closeButtons.forEach((button) => button.addEventListener('click', closeMenu));
    panel?.addEventListener('keydown', trapFocus);

    root.querySelectorAll('.cw-header__nav details').forEach((detail) => {
      detail.addEventListener('toggle', () => {
        if (!detail.open) return;
        root.querySelectorAll('.cw-header__nav details[open]').forEach((other) => {
          if (other !== detail) other.removeAttribute('open');
        });
      });
    });

    document.addEventListener('click', (event) => {
      if (!event.target.closest('.cw-header .cw-header__nav details')) {
        root.querySelectorAll('.cw-header__nav details[open]').forEach((detail) => detail.removeAttribute('open'));
      }
    });

    root.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      root.querySelectorAll('.cw-header__nav details[open]').forEach((detail) => {
        const shouldRestoreFocus = detail.contains(document.activeElement);
        detail.removeAttribute('open');
        if (shouldRestoreFocus) detail.querySelector('summary')?.focus();
      });
    });

    window.addEventListener('scroll', requestStickyUpdate, { passive: true });
    window.addEventListener('resize', requestStickyUpdate, { passive: true });
    updateStickyState();
  });
})();
